var map = {
	"./vana1.mp3": 5443,
	"./vana2.mp3": 6851,
	"./vana3.mp3": 8989,
	"./vana4.mp3": 8913,
	"./vana5.mp3": 427,
	"./vana6.mp3": 1696
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6354;